
export const userTimelineDataType = {
    Text: 0,
    Image: 1,
    Video: 2,
    Fixture: 3,
    Challenge: 4,
    Player: 5,
    Ladder: 6,
    League: 7,
    LeagueCycle: 8,
    LeagueCycleDivision: 9,
    Club: 10,
    AccessApplication: 11,
    TournamentStage: 12
};
